import { DatePicker, DateTimePicker, MultiViewCalendar, MultiViewCalendarProps } from '@progress/kendo-react-dateinputs'
import { ComboBox,ComboBoxFilterChangeEvent,MultiSelect } from '@progress/kendo-react-dropdowns'
import { Field, Form, FormElement, FormRenderProps } from '@progress/kendo-react-form'
import {
  Checkbox,
  Input,
  RadioGroup,
  TextArea
} from '@progress/kendo-react-inputs'
import { MouseEvent as ReactMouseEvent, useEffect, useState } from 'react'

import {
  acaoEstado,
  acaoPlaneamento1,
  acaoPlaneamento2,
  acaoPlaneamento3,
  acaoPlaneamento4,
  arhs,
  capitania,
  codigoCandidatura,
  codigoIntervencao,
  componenteAcao,
  concelhos,
  designacaoIntervencao,
  distritos,
  entidades,
  entidadeUser,
  fillAcaoPlaneamento1Async,
  fillAcaoPlaneamento2Async,
  fillAcaoPlaneamento3Async,
  fillAcaoPlaneamento4Async,
  fillArhsAsync,
  fillCapitaniaAsync,
  fillCodigoCandidaturaAsync,
  fillCodigoIntervencaoAsync,
  fillCombosAuxiliares,
  fillComponenteAcaoAsync,
  fillConcelhosAsync,
  fillDesignacaoIntervencaoAsync,
  fillDistritosAsync,
  fillEntidadesAsync,
  fillFreguesiasAsync,
  fillMassaAguaAsync,
  fillNaturezaAcaoAsync,
  fillNuts1Async,
  fillNuts2Async,
  fillNuts3Async,
  fillPrioridadeAsync,
  fillProcContratacaoAsync,
  fillTipoEngenhariaAsync,
  fillTipoPlanemanetoAsync,
  formatCurrency,
  formatCurrency_normalise,
  freguesias,
  get,
  getAcaoSelected,
  hasPermission,
  intIndicador,
  massaagua,
  naturezaAcao,
  normalizeNumber,
  nuts1,
  nuts2,
  nuts3,
  post,
  praias,
  prioridade,
  procContratacao,
  put,
  setAcaoSelected,
  tipoEngenharia,
  tipoPlaneamento,
  useCombos
} from '../../services/utils'
import styles from '../../styles/intervencao/Intervencao.module.scss'
import { Dialog } from '@progress/kendo-react-dialogs'

import { Button } from '@progress/kendo-react-buttons'
import { useAcaoStore } from '../../stores/acao'
import { CONSULTAR_CANDIDATURA, CONSULTAR_CANDIDATURA_ACOES, CONSULTAR_MOBILIZACAO, CONSULTAR_MOBILIZACAO_ACAO, GET_INT_ACAO_INDICADORES, GET_INTERVENCAO_ACAO_BY_ID_ACAO, GET_LIST_RESULTS_FONTE_FINANCIAMENTO, GET_LIST_RESULTS_FONTE_FINANCIAMENTO_BY_ID, IMPORT_GEOM_ACAO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_TOTAL, PESQUISAR_ACAO, PESQUISAR_ENTIDADEBYUSER, PESQUISAR_INTERVENCOES_ACAO, SAVE_NEW_ACAO, UPDATE_ACAO } from '../../utils/constants'
import ImportarGeometriaComponent from '../apoiogestao/registar/ImportarGeometriaForm'
import CheckMoreItem from '../documentos/registar/fields/CheckMoreItem'
import AssociacaoEntidadeIntervencao from './AssociacaoEntidade'
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query'
import { faInfoCircle, faRemove } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import { v4 as uuidv4 } from 'uuid';
import SessionStorageService from '../../services/SessionStorageService'
import PesquisarAcao from './PesquisarAcao'
import CurrencyInput from 'react-currency-input-field'


type IProps = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
  formRenderProps: FormRenderProps
  viewMode?: boolean
  datagrid?: any
  setDataGrid?: any
  invPrevisto?: any
  setInvPrevisto?: any
  valContrat?: any
  setValContrat?: any
  revisaoPrecos?: any
  setRevisaoPrecos?: any
  valPorExecutar?: any
  setValPorExecutar?: any
  invRealizado?: any
  setInvRealizado?: any
}

interface FormData {
  id?: any;
  id_interv?: any;
  designacao?: any;
  codigo?: any;
  intEstado?: any;
  id_int_instrumento_planeamento?: string;
  id_int_palXXI_tip_nivel1?: string;
  id_int_palXXI_tip_nivel2?: string;
  id_int_palXXI_tip_nivel3?: any;
  numero_intervencao?: string;
  id_prioridade?: string;
  percentagem?: any;
}

interface FormDataFonteFinanciamento {
  id?: any;
  id_entidade?: any;
  valor_financiamento?: any;
}


interface FormDataAssociacaoCandidatura {
  id?: any;
  id_candidatura?: any;
  intInstrumentoFinanciamento?: any;
  codigo_comunitario?: any;
  intCandidaturaEstado?: any;
  valor_comunitario?: any;
  valor_nacional?: any;
  inv_previsto?: any;
}




export default function IdentificacaoAcao({ onCloseClick, formRenderProps, viewMode,  datagrid, setDataGrid, invPrevisto, setInvPrevisto, valContrat, setValContrat, revisaoPrecos, setRevisaoPrecos, valPorExecutar, setValPorExecutar, invRealizado , setInvRealizado}: IProps) {
  const [openImportModal, setOpenImportModal] = useState<any>()
  const [concelhosFiltred, setConcelhosFiltred] = useState<any>(undefined)
  const [concelhosDisabled, setConcelhosDisabled] = useState<any>(true)
  const [freguesiasFiltred, setFreguesiasFiltred] = useState<any>(undefined)
  const [freguesiasDisabled, setFreguesiasDisabled] = useState<any>(true)
  const [nuts2Filtered, setNuts2Filtered] = useState<any>(undefined)
  const [nuts2Disabled, setNuts2Disabled] = useState<any>(true)
  const [nuts3Filtered, setNuts3Filtered] = useState<any>(undefined)
  const [nuts3Disabled, setNuts3Disabled] = useState<any>(true)
  const [findIntervencao, setFindIntervencao] = useState<any>(false)
  const [findCandidatura, setFindCandidatura] = useState<any>(false)
  
  const [formData, setFormData] = useState<FormData>({});
  const [gridData, setGridData] = useState<FormData[]>([]);
  const [gridDataCandidaturas, setGridDataCandidatura] = useState<FormDataAssociacaoCandidatura[]>([]);
  const [gridDataMobilizacoes, setGridDataMobilizacoes] = useState<FormDataAssociacaoCandidatura[]>([]);
  const [formDataCandidaturas, setFormDataCandidaturas] = useState<FormDataAssociacaoCandidatura>({});
  const [formDataFonteFinanciamento, setFormDataFonteFinanciamento] = useState<FormDataFonteFinanciamento>({});
  const [gridDataFonteFinanciamento, setGridDataFonteFinanciamento] = useState<FormData[]>([]);

  const [tipoN1, setTipoN1] = useState<any>('');
  const [tipoN2, setTipoN2] = useState<any>('');
  const [tipoN3, setTipoN3] = useState<any>('');

  const [openModalDescartarIndicador, setOpenModalDescartarIndicador] = useState<any>()
  const [openModalDescartarAssociacaoCandidatura, setOpenModalDescartarAssociacaoCandidatura] = useState<any>()
  const [openModalFonteFinanciamento, setOpenModalFonteFinanciamento] = useState<any>()

  const [idInterv, setIdInterv] = useState<any>();
  const [designacao, setDesignacao] = useState<any>();
  const [codigo, setCodigo] = useState<any>();
  
  const [gridDataIndicadores, setGridDataIndicadores] = useState<FormData[]>([]);

  //  VALIDAÇÕES CURRENCY INPUT
  const [invPrevistoFocused, setInvPrevistoFocused] = useState(false);
  const [valContratFocused, setValContratFocused] = useState(false);
  const [valPorExecutarFocused, setValPorExecutarFocused] = useState(false);
  const [invRealizadoFocused, setInvRealizadoFocused] = useState(false);
  const [revisaoPrecosFocused, setRevisaoPrecosFocused] = useState(false);
  const [entidadesData, setEntidadesData] = useState(entidades ? entidades.slice() : []);


  const getIntervencaoAcao = async (data: any) =>
    await post<any, any>(`${GET_INTERVENCAO_ACAO_BY_ID_ACAO}`, data)

  const getIndicadores = async (data: any) =>
    await post<any, any>(`${GET_INT_ACAO_INDICADORES}`, data)

  const getAcaoFonteFinanciamento = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_FONTE_FINANCIAMENTO_BY_ID}`, data)


  const handleValContratChange = (event: any) => {
    const valueString = event.value.replace('€', '').replace(',', '.').trim();
    
    const value = parseFloat(valueString) || 0;
    
    SessionStorageService.setItem("valor_contratado", value);
    setValContrat(value);
  };

  const handleValRevisaoPrecosChange = (event : any) => {

    const valueString = event.value.replace('€', '').replace(',', '.').trim();
    
    const value = parseFloat(valueString) || 0;
    
    SessionStorageService.setItem("revisao_precos" , value)
    setRevisaoPrecos(value);
  };
  
  useEffect(() => {
    if (getAcaoSelected()?.id) {
      formRenderProps.onChange('id', { value: getAcaoSelected()?.id });
    }
  }, [getAcaoSelected()?.id])

  useEffect(() => {
    if (selectedAcaoResult?.id) {
      const fetchData = async () => {
          const data = await getAcaoFonteFinanciamento(selectedAcaoResult?.id);
          setGridDataFonteFinanciamento(data);
      };
      fetchData();
  }
  }, []);

  const selectedAcaoResult: any = useAcaoStore(
    (state) => state.selectedAcaoResult
  )
  const selectedAcaoResultId = useAcaoStore(
    (state) => state.selectedAcaoResultId
  )

  const getEntidadeByUser = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)
  
    useEffect(() => {
    
     if(!nuts1 ){
      fillNuts1Async();
      }
     if(!nuts2) {
      fillNuts2Async();
     }
     if(!nuts3){
      fillNuts3Async();
     }
     if(!distritos){
      fillDistritosAsync();
     }
     if(!concelhos){
      fillConcelhosAsync();
     }
     if(!freguesias){
      fillFreguesiasAsync();
     }
     if(!arhs){
      fillArhsAsync();
     }
     if(!capitania){
      fillCapitaniaAsync();
     }
     if(!massaagua){
      fillMassaAguaAsync();
     }
     if(!acaoPlaneamento1){
      fillAcaoPlaneamento1Async();
     }
     if(!acaoPlaneamento2){
      fillAcaoPlaneamento2Async();
     }
     if(!acaoPlaneamento3){
      fillAcaoPlaneamento3Async();
     }
     if(!acaoPlaneamento4){
      fillAcaoPlaneamento4Async();
     }
     if(!tipoEngenharia){
      fillTipoEngenhariaAsync();
     }
     if(!naturezaAcao){
      fillNaturezaAcaoAsync();
     }

      if(!componenteAcao){
      fillComponenteAcaoAsync();
     }
      if(!tipoPlaneamento){
      fillTipoPlanemanetoAsync();
     }
     if(!prioridade){
      fillPrioridadeAsync();
     }
     if(!entidades){
      fillEntidadesAsync();
     }
     if(!designacaoIntervencao){
      fillDesignacaoIntervencaoAsync();
     }
     if(!codigoIntervencao){
      fillCodigoIntervencaoAsync();
     }
     if(!codigoCandidatura){
      fillCodigoCandidaturaAsync();
     }
     if(!procContratacao){
      fillProcContratacaoAsync();
     }

     if(getAcaoSelected()?.utilizador) {
      getEntidadeByUser(getAcaoSelected()?.utilizador?.id).then(resultEntidade => {
        formRenderProps.onChange('entidade_registo', { value: resultEntidade?.nome });
      });
    }else{
      formRenderProps.onChange('entidade_registo', { value: entidadeUser });
    }
  }, []);
  
  useEffect(() => {
    SessionStorageService.setItem("dataIntervencaoAcao", gridData);
    SessionStorageService.setItem("dataIndicadores", gridDataIndicadores);
    SessionStorageService.setItem("dataCandidaturaAcao", gridDataCandidaturas);
    SessionStorageService.setItem("dataMobilizacaoAcao", gridDataMobilizacoes);
    SessionStorageService.setItem("dataFonteFinanciamento", gridDataFonteFinanciamento);
  });

  useEffect(() => {
    if (getAcaoSelected()?.id && getAcaoSelected()?.praia) {
      formRenderProps.onChange('praia', { value: getAcaoSelected()?.praia }) 
    }
  }, [getAcaoSelected()?.praia]);

  useEffect(() => {
    if (selectedAcaoResult?.id) {
      const fetchData = async () => {
        const objToSearch = {
          id_acao: selectedAcaoResult.id,
        };
  
        const dataCandidaturaAcao = await pesquisarCandidaturaAcoes(objToSearch);
        const formattedCandidaturas = [];
  
        for (const item of dataCandidaturaAcao) {
          const objtToSearch2 = {
            id: item?.id_candida,
          };
  
          if (objtToSearch2.id !== undefined) {
            const dataCandidatura = await pesquisarCandidatura(objtToSearch2);
  
            formattedCandidaturas.push(dataCandidatura[0]);
          }
        }
  
        setGridDataCandidatura(formattedCandidaturas);
      };
  
      fetchData();
    }
  }, []);
  
  useEffect(() => {
    if (getAcaoSelected()?.id) {
      const fetchData = async () => {
  
        const dataMobilizacaoAcao: any[] = await pesquisarMobilizacaoAcao(getAcaoSelected()?.id);
        const formatedMobilizacoes : any[]= [];
        for(const itemMob of dataMobilizacaoAcao){
          const objtToSearch = {
            id: itemMob?.id_mobiliz
          };
    
          if (objtToSearch?.id !== undefined) {
            const dataMobilizacao = await pesquisarMobizacao(objtToSearch);
    
            const formattedData = dataMobilizacao.map((item: any) => {
              const volumeAcao = dataMobilizacaoAcao.find((acao: any) => acao.id_mobiliz === item.id)?.volume || 0;
              
              return {
                ...item,
                   data_inicio:item.data_inicio? new Date(item.data_inicio).toLocaleDateString("pt-PT") : "",
                   data_fim: item.data_fim? new Date(item.data_fim).toLocaleDateString("pt-PT") : "",
                   volume_acao: volumeAcao 
              };
            });
            formatedMobilizacoes.push(formattedData[0]);
            
          }
        }
        setGridDataMobilizacoes(formatedMobilizacoes);
      };
  
      fetchData();
    }
  }, []);

  let data : any;
  useEffect(() => {
    if(selectedAcaoResult?.id){
    const fetchData = async () => {
       data = await getIntervencaoAcao(selectedAcaoResult?.id);
       data = data.map((item: any) => ({
        ...item,
        codigo: { codigo: item.codigo },
        designacao: { designacao: item.designacao },
      }));

      setGridData(data);      
      if (data.length > 0) {
        const lastIndex = data.length - 1;
        const lastItem = data[lastIndex];

        formRenderProps.onChange('id_tipo_n1', { value: lastItem?.id_int_palXXI_tip_nivel1 });
        formRenderProps.onChange('id_tipo_n2', { value: lastItem.id_int_palXXI_tip_nivel2 });
        formRenderProps.onChange('id_tipo_n3', { value: lastItem.id_int_palXXI_tip_nivel3 });
      }
      const dataIndicadores = await getIndicadores(selectedAcaoResult?.id);
      setGridDataIndicadores(dataIndicadores);

    };
    fetchData();
    
  }
  
  },[data]);
  
  let lstAcaoExecucao : any;

  const val_contratado = normalizeNumber(SessionStorageService.getItem("valor_contratado")) || 0;

  useEffect(() => {
    lstAcaoExecucao = SessionStorageService.getItem("dataAcaoExecucao");
    const revisaoPrecos = parseFloat(SessionStorageService.getItem("revisao_precos")) || 0;
  
    if (lstAcaoExecucao?.length > 0 && selectedAcaoResult?.id) {
      const inv_realizado = lstAcaoExecucao?.reduce((sum : any, item : any) => sum + (parseFloat(item?.valor_total) || 0), 0) + revisaoPrecos;
      formRenderProps.onChange('inv_realizado', { value: inv_realizado });
      setInvRealizado(inv_realizado);
  
      
     const valContratual = Number(val_contratado) || 0;
     const invRealizado = Number(inv_realizado) || 0;

      const valor_por_executar = valContratual > 0
        ? Math.max(valContratual - invRealizado, 0)
        : 0;

      let taxa_execucao: string | number | undefined = 0;
      const contratado = normalizeNumber(valContrat);

      if (contratado > 0) {
        if ((contratado - invRealizado) > 0) {
          taxa_execucao = (invRealizado / contratado) * 100;
        } else {
          taxa_execucao = 100;
        }
      }

      taxa_execucao = formatCurrency_normalise(taxa_execucao);

    formRenderProps.onChange("valor_por_executar", { value: valor_por_executar });
    setValPorExecutar(valor_por_executar);

    formRenderProps.onChange("taxa_execucao", { value: taxa_execucao });

    }
  },[revisaoPrecos, val_contratado]);

  const [EntidadeData, setEntidadeData] = useState(entidades ? entidades.slice() : []);
  const saveAcao = async (data: any) => await post<any, any>(`${SAVE_NEW_ACAO}`, data)
  const updateAcao = async (data: any) => await put<any, any>(`${UPDATE_ACAO}`, data)
  const getAcaoById = async (id: any) =>
    await get<any, any>(`${PESQUISAR_ACAO}/` + id)
  const importGeomIntAcao = async (data: any) =>
    await post<any, any>(`${IMPORT_GEOM_ACAO}`, data)

  const pesquisarIntervencao = async (data: any) => await post<any, any>(`${PESQUISAR_INTERVENCOES_ACAO}`, data)

  const pesquisarCandidatura = async (data: any) => await post<any, any>(`${CONSULTAR_CANDIDATURA}`, data)
  
  const pesquisarCandidaturaAcoes = async (data: any) => await post<any, any>(`${CONSULTAR_CANDIDATURA_ACOES}`, data)

  const pesquisarMobilizacaoAcao = async (data: any) => await post<any, any>(`${CONSULTAR_MOBILIZACAO_ACAO}`, data)

  const pesquisarMobizacao = async (data: any) => await post<any, any>(`${CONSULTAR_MOBILIZACAO}`, data) 

  const [itemToRemove, setItemToRemove] = useState<any>();

  const [openModalIntervencaoAcao, setOpenModalIntervencaoAcao] = useState<any>()
  const [openModalAssociacaoCandidatura, setOpenModalAssociacaoCandidatura] = useState<any>()
  const [openModalDescartar, setOpenModalDescartar] = useState<any>()
  const [openModalDescartarFinanciamento, setOpenModalDescartarFinanciamento] = useState<any>()
  const [selectedGridItemId, setSelectedGridItemId] = useState<string | null>(null);
  const [selectedGridItemIdCandidatura, setSelectedGridItemIdCandidatura] = useState<string | null>(null);

  const [selectedIndicador, setSelectedIndicador] = useState(null);
  const [valorIndicador, setValorIndicador] = useState(null);


  const [page2, setPage2] = useState({ skip: 0, take: 10 });
  const [pageFonteFinanciamento, setPageFonteFinanciamento] = useState({ skip: 0, take: 10 });

  const selectAcaoResult = useAcaoStore(
    (state) => state.selectAcaoResult
  )
  const selectAcaoResultId = useAcaoStore(
    (state) => state.selectAcaoResultId
  )

 
  const filterConcelho = (e: any) => {
    if (e?.value?.codigo) {
      const concelhosLocal = concelhos.filter(
        (x: any) => x.distrito_cod == e.value.codigo
      )
      setConcelhosFiltred(concelhosLocal)
      setConcelhosDisabled(false)
    } else {
      setConcelhosFiltred(concelhos)
      setConcelhosDisabled(true)
    }
  }

  const filterFreguesia = (e: any) => {
    if (e?.value?.codigo) {
      const freguesiaLocal = freguesias.filter(
        (x: any) => x.concelho_cod == e.value.codigo
      )
      setFreguesiasFiltred(freguesiaLocal)
      setFreguesiasDisabled(false)
    } else {
      setFreguesiasDisabled(true)
      setFreguesiasFiltred(freguesias)
    }
  }
  const filterNuts2 = (e: any) => {
    if (e?.value?.codigo) {
      const nutsLocal = nuts2.filter((x: any) => x.nuts_i_cod == e.value.codigo)
      setNuts2Filtered(nutsLocal)
      setNuts2Disabled(false)
    } else {
      setNuts2Disabled(true)
      setNuts2Filtered(nuts2)
    }
  }
  const filterNuts3 = (e: any) => {
    if (e?.value?.codigo) {
      const nutsLocal = nuts3.filter(
        (x: any) => x.nuts_ii_cod == e.value.codigo
      )
      setNuts3Filtered(nutsLocal)
      setNuts3Disabled(false)
    } else {
      setNuts3Disabled(true)
      setNuts3Filtered(nuts3)
    }
  }
  type combosKeys = 'acaoEstado'
  |'acaoPlaneamento1'| 'acaoPlaneamento2' | 'acaoPlaneamento3'|'acaoPlaneamento4'
  |'tipoEngenharia' | 'naturezaAcao' |'componenteAcao' | 'tipoPlaneamento'
  |'entidades' | 'praias' | 'designacaoIntervencao' | 'codigoIntervencao' | 'codigoCandidatura';

  const [combos, setCombos] = useState<any>({
    acaoEstado, 
    entidades, 
    acaoPlaneamento1, 
    acaoPlaneamento2,
    acaoPlaneamento3,
    acaoPlaneamento4,
    tipoEngenharia,
    naturezaAcao,
    componenteAcao,
    tipoPlaneamento,
    praias,
    designacaoIntervencao,
    codigoIntervencao,
    codigoCandidatura
  })
  const setDataOption: Record<combosKeys, { setFn: any, data: any[] }> = {
    acaoEstado: { setFn: setCombos, data: acaoEstado },
    entidades: { setFn: setCombos, data: entidades },
    acaoPlaneamento1: { setFn: setCombos, data: acaoPlaneamento1 },
    acaoPlaneamento2: { setFn: setCombos, data: acaoPlaneamento2 },
    acaoPlaneamento3: { setFn: setCombos, data: acaoPlaneamento3 },
    acaoPlaneamento4: { setFn: setCombos, data: acaoPlaneamento4 },
    tipoEngenharia: { setFn: setCombos, data: tipoEngenharia },
    naturezaAcao: { setFn: setCombos, data: naturezaAcao },
    componenteAcao: { setFn: setCombos, data: componenteAcao },
    tipoPlaneamento: { setFn: setCombos, data: tipoPlaneamento },
    praias: { setFn: setCombos, data: praias },
    designacaoIntervencao: { setFn: setCombos, data: designacaoIntervencao },
    codigoIntervencao: { setFn: setCombos, data: codigoIntervencao },
    codigoCandidatura: { setFn: setCombos, data: codigoCandidatura }
  };

  const filterDataEntidades = (filter: FilterDescriptor) => {
    const data = entidades?.slice();
    return filterBy(data, filter);
  };
  
  const filterChangeEntidades = (event: ComboBoxFilterChangeEvent) => {
    setEntidadesData(filterDataEntidades(event?.filter));
  };

  const filterCombo_Multiselect = (e: any, tipoCombo: combosKeys) => {
    const { setFn, data } = setDataOption[tipoCombo];
      setFn({
          ...combos,
          [tipoCombo]: filterBy(data?.slice()??[], e.filter)
      }
      );
  }
  const filterChange = (event: any) => {
    setEntidadeData(filterBy(entidades.slice(), event.filter));
  };

  const [multiData, setMultiData] = useState([])

  async function HandleOnChangeMultiData(e: any) {
    if (e?.value) {
      setMultiData(e?.value) 
    }
  }

const changeFileDoc = (e: any) => {
  setAcaoSelected({...getAcaoSelected(), n_filedoc: e?.value})
}

const CustomCalendar = (props: MultiViewCalendarProps) => {
  return <MultiViewCalendar {...props} views={1} />
}

const openModal = (e : any) => {
  setFormData({
    id_interv: "",
    designacao: "",
    codigo: "",
    intEstado: "",
    id_int_palXXI_tip_nivel1: "",
    id_int_palXXI_tip_nivel2: "",
    id_int_palXXI_tip_nivel3: "",
    id_prioridade: "",
    });
    setIdInterv(undefined);
    setDesignacao(undefined);
    setCodigo(undefined);
    setSelectedGridItemId(null)
  e.preventDefault();
  setOpenModalIntervencaoAcao(true)
  setFindIntervencao(false)
}


const cancelModal = () => {
  setOpenModalIntervencaoAcao(false)
}

const cancelModalFinanciamentonacional = () => {
  setOpenModalFonteFinanciamento(false)
}

const handleAddItem = (item : any) => {
  const newItem = { ...item, id: uuidv4()};
  setGridData([...gridData, newItem]);

};

const handleUpdateItem = (id : any, updatedItem : any) => {
    setGridData(prevData => prevData.map(item => item.id === id ? { ...updatedItem, id } : item));
};

const handleAddItemFinanciamentoNacional = (item : any) => {
  const newItem = { ...item, id: uuidv4()};
  setGridDataFonteFinanciamento([...gridDataFonteFinanciamento, newItem]);

};

const handleUpdateItemFinanciamentoNacional = (id : any, updatedItem : any) => {
  setGridDataFonteFinanciamento(prevData => prevData.map(item => item.id === id ? { ...updatedItem, id } : item));
};


const removeFonteFinanciamento: any = () => {
  const item = itemToRemove;
  const data = gridDataFonteFinanciamento.filter(x => !(x.id == item.id)).slice();
  setGridDataFonteFinanciamento(data);
  setOpenModalDescartarFinanciamento(false);
}

const confirmRemoveFonteFinanciamento = (item: any) => {
  setItemToRemove(item);
  setOpenModalDescartarFinanciamento(true);
}

const removeAssociacaoIntervencao: any = () => {
  const item = itemToRemove;
  const dataIntervencaoAcao = gridData.filter(x => !(x.id == item.id)).slice();
  setGridData(dataIntervencaoAcao);
  setOpenModalDescartar(false);

  if (dataIntervencaoAcao?.length > 0) {
    const lastIntervencao = dataIntervencaoAcao[dataIntervencaoAcao?.length - 1];

    formRenderProps.onChange('id_tipo_n1', { value: lastIntervencao?.id_int_palXXI_tip_nivel1 });
    formRenderProps.onChange('id_tipo_n2', { value: lastIntervencao?.id_int_palXXI_tip_nivel2 });
    formRenderProps.onChange('id_tipo_n3', { value: lastIntervencao?.id_int_palXXI_tip_nivel3 });
  } else {
    formRenderProps.onChange('id_tipo_n1', { value: "" });
    formRenderProps.onChange('id_tipo_n2', { value: "" });
    formRenderProps.onChange('id_tipo_n3', { value: "" });
  }
 
}

const confirmRemoveAssociacaoIntervencao = (item: any) => {
  setItemToRemove(item);
  setOpenModalDescartar(true);
}


const removeIndicador: any = () => {
  const item = itemToRemove;
  const dataIndicadorLocal = gridData.filter(x => !(x.id == item.id)).slice();
  setGridDataIndicadores(dataIndicadorLocal);
  setOpenModalDescartarIndicador(false);
}


const confirmRemoveIndicador = (item: any) => {
  setItemToRemove(item);
  setOpenModalDescartarIndicador(true);
}





const isUUID = (str: string) => {
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidPattern.test(str);
};

const handlePesquisarIntervencao = async (e : any, formRenderProps : FormRenderProps) => {
  e.preventDefault();

  if ((!idInterv || idInterv == "") && !designacao && !codigo) {
    postMessage({type: "infoMsg", value: {message: "Preencha o id, designação ou o código"}}, "*");
    return;
  }

  const intervencaoRequest = {
    id_interv: idInterv ?? undefined,
    designacao: designacao?.designacao ?? undefined,
    codigo: codigo?.codigo ?? undefined,
  };

  try {
    const data = await pesquisarIntervencao(intervencaoRequest);
    if (data) {
     setFindIntervencao(true)

     const dataObjectCodigo = {
      codigo: data?.codigo
     }

     const dataObjectDesignacao = {
      designacao: data?.designacao
     }
     formRenderProps.onChange('id_interv', { value: data?.id_interv}) 
     formRenderProps.onChange('designacao', { value: dataObjectDesignacao}) 
     formRenderProps.onChange('codigo', { value: dataObjectCodigo}) 
     formRenderProps.onChange('id_int_palXXI_tip_nivel1', { value: data?.int_pal_xxi_tip_nivel_1?.descricao}) 
     formRenderProps.onChange('id_int_palXXI_tip_nivel2', { value: data?.int_pal_xxi_tip_nivel_2?.descricao}) 
     formRenderProps.onChange('id_int_palXXI_tip_nivel3', { value: data?.int_pal_xxi_tip_nivel_3}) 
     formRenderProps.onChange('intEstado', { value: data?.intEstado}) 
     setFormData({
      id_interv: data?.id_interv,
      designacao: dataObjectDesignacao,
      codigo: dataObjectCodigo,
      intEstado: data?.intEstado,
      id_int_palXXI_tip_nivel1: data?.int_pal_xxi_tip_nivel_1,
      id_int_palXXI_tip_nivel2: data?.int_pal_xxi_tip_nivel_2,
      id_int_palXXI_tip_nivel3: data?.int_pal_xxi_tip_nivel_3,
      });
    
    } else {
      postMessage({ type: 'errorMsg', value: { left: "15%" , message: "Não foi encontrada nenhuma intervenção." } }, '*');
    }
  } catch (error) {
    console.error("Erro ao pesquisar intervenção:", error);
  }
};

const handleSubmitModal = (e : any) => {

    if (!formData.percentagem || formData.percentagem <= 0) {
      postMessage({ type: "informationMsg", value: "O campo percentagem é obrigatório" }, "*");
    return; 
  }


  if (selectedGridItemId) {
      handleUpdateItem(selectedGridItemId, formData);
  } else {
      const newId = uuidv4();
      handleAddItem({ ...formData, id: newId });
      setSelectedGridItemId(newId);
  }

  formRenderProps.onChange('id_tipo_n1', { value: formData?.id_int_palXXI_tip_nivel1 });
  formRenderProps.onChange('id_tipo_n2', { value: formData.id_int_palXXI_tip_nivel2 });
  formRenderProps.onChange('id_tipo_n3', { value: formData.id_int_palXXI_tip_nivel3 });

  setOpenModalIntervencaoAcao(false);
};

const handleSubmitModalFonteFinanciamento = (e : any) => {
  if (selectedGridItemId) {
      handleUpdateItemFinanciamentoNacional(selectedGridItemId, formDataFonteFinanciamento);
  } else {
      const newId = uuidv4();
      handleAddItemFinanciamentoNacional({ ...formDataFonteFinanciamento, id: newId });
      setSelectedGridItemId(newId);
  }

  setOpenModalFonteFinanciamento(false);
};

const handleRowClick = (dataItem : any) => {
  setFindIntervencao(true)

    const id = dataItem?.id; 

  setSelectedGridItemId(id); 

  const dataItemObject = {
    designacao: dataItem?.designacao,
    codigo: dataItem?.codigo,
  };

  setFormData({
    id_interv: dataItem?.id_interv,
    designacao : dataItemObject.designacao,
    codigo : dataItemObject.codigo,
    intEstado: dataItem?.intEstado,
    id_int_palXXI_tip_nivel1: dataItem?.id_int_palXXI_tip_nivel1?.descricao,
    id_int_palXXI_tip_nivel2: dataItem?.id_int_palXXI_tip_nivel2?.descricao,
    id_int_palXXI_tip_nivel3: dataItem?.id_int_palXXI_tip_nivel3,
    id_prioridade: dataItem?.id_prioridade,
    percentagem: dataItem?.percentagem
  });

  setOpenModalIntervencaoAcao(true);
};

const handlePageChange2 = (event : any) => {
  setPage2({ skip: event.page2.skip, take: event.page2.take });
};


const handlePageChangeFonteFinanciamento = (event: any) => { 
  setPageFonteFinanciamento({ skip: event.page.skip, take: event.page.take });
};

const handleFormChangeFonteFinanciamento = (event : any) => {
  
  setFormDataFonteFinanciamento({
    ...formDataFonteFinanciamento,
    [event.target.name]: event.target.value,
  });

  
};

const handleFormChange = (event : any) => {
  
  setFormData({
    ...formData,
    [event.target.name]: event.target.value,
  });

  if (event.target.name === 'id_interv') {
    setIdInterv(event.target.value);
  }
};

const modalFonteFinanciamento = (e : any) => {
  setFormDataFonteFinanciamento({
    id: "",
    id_entidade: undefined,
    valor_financiamento: "",
    });
    setSelectedGridItemId(null)
    e.preventDefault();
    setOpenModalFonteFinanciamento(true)
}


const handleKeyPress = (e : any) => {
  
  if(viewMode){
    e.preventDefault();
    return false
  }
};

const handleInsertIndicador = () => {
  if (selectedIndicador) {
    const newItem = {
      id: uuidv4(),
      id_indicador: selectedIndicador,
      valor: valorIndicador
    };
    setGridDataIndicadores([...gridDataIndicadores, newItem]);
  }
  formRenderProps.onChange('id_indicador', { value: "" }) 
  formRenderProps.onChange('valor', { value: "" }) 
  setSelectedIndicador(null);
  setValorIndicador(null)

};

const keyPressTextArea = (e: any) => {
  if (viewMode) {
    e.preventDefault();
    return false;
  }
}

  
  const handleRowClickFonteFinanciamento = (dataItem : any) => {
  
    setSelectedGridItemId(dataItem?.id); 
      setFormDataFonteFinanciamento({
          id_entidade: dataItem.id_entidade ?? undefined,
          valor_financiamento: dataItem.valor_financiamento ?? undefined,
      });
  
   setOpenModalFonteFinanciamento(true);
  };

  return (
    <>
      <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
        <fieldset>
          <legend>
            <span className={styles.fieldsetTitulo}>Registo</span>
          </legend>

          <div className={` ${styles.espacoVerticalFieldSet}`}>
            <div className={styles.fields}>
              <div>
                <Field name="id" label="ID" component={Input} disabled />
              </div>
              {
                      hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL) ||
                      hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
                      hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA)?<>
             
              <div>
                <Field
                  name="n_filedoc"
                  label="Nº Processo APA"
                  component={Input}
                  maxLength={250}
                  onChange={changeFileDoc}
                  disabled={viewMode}

                />
              </div>
              </>:<></>}
              <div>
                <Field
                  name="acaoEstado"
                  label="Estado"
                  component={ComboBox}
                  textField={'descricao'}
                  filterable={true}
                  onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'acaoEstado')}}
                  data={combos?.acaoEstado}
                  disabled={viewMode}

                />
              </div>
            </div>
            <div className={styles.fields}>
            <div>
                <Field
                  name="data_registo"
                  label="Data/hora registo"
                  component={DateTimePicker}  
                  format="dd/MM/yyyy HH:mm"
                  calendar={CustomCalendar}
                  disabled={true}
                />
              </div>
              <div>
              <Field
                name="utilizador_id"
                label="Técnico de registo"
                disabled
                component={Input}
              />
            </div>
            <div>
              <Field
                name="entidade_registo"
                label="Entidade"
                component={Input}
                disabled
              />
            </div>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>
            <span className={styles.fieldsetTitulo}>Identificação</span>
          </legend>
          <div className={`${styles.fields}`}>
            <div>
                <Field name="designacao" label="Designação" maxLength={250} component={Input} disabled={viewMode}/>
            </div>
            </div>
            <div className={`${styles.fields}`}>
            {
                      hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL) ||
                      hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
                      hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA)?<>
              <div>
                <Field
                  name="n_processo_aquisitivo"
                  label="N.º de processo aquisitivo"
                  component={Input}
                  maxLength={25}
                  disabled={viewMode}

                />
              </div>
               </>:<></>}
            <div>
                <Field
                  name="id_proc_contratacao"
                  label="Procedimento de contratação"
                  component={ComboBox} 
                  textField={'descricao'}
                  data={procContratacao}
                  disabled={viewMode}       />
              </div>
             
            
            </div>

            <div className={`${styles.fields} `}>
            <div>
              <Field
                name="data_tutela"
                label="Data da tutela"
                component={DatePicker}
                calendar={CustomCalendar}
                format="dd/MM/yyyy"
                disabled={viewMode}
              />
            </div>
            <div>
            <Field
                name="data_tc"
                label="Data do tribunal de contas"
                component={DatePicker}
                calendar={CustomCalendar}
                format="dd/MM/yyyy"
                disabled={viewMode}
              />
            </div>
            <div>
            <Field
                name="data_artigo"
                label="Data Artigos 64.º e 66.º da LOE"
                component={DatePicker}
                calendar={CustomCalendar}
                format="dd/MM/yyyy"
                disabled={viewMode}
              />
            </div>
           
          </div>

            <div className={`${styles.fields} `}>
            {hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA) ||hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA)  ||hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO)  ||hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL) ? <>

                <div>
                <Field
                  name="data_ini_p"
                  label="Data de início prevista"
                  component={DatePicker}
                  calendar={CustomCalendar}
                  format="dd/MM/yyyy"
                  disabled={viewMode}
              />
              </div>
              <div>
              <Field
                name="data_con_p"
                label="Data de conclusão prevista"
                component={DatePicker}
                calendar={CustomCalendar}
                format="dd/MM/yyyy"
                disabled={viewMode}
              />
              </div>
              </>:<></>}

              {hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA) ||
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA)  ||
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO)  ||
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL)? <>
         
            <div className={styles.fields}>
              <div>
                <span className={`k-floating-label-container ${invPrevisto == null || invPrevisto == undefined ? "k-empty" : ""} ${invPrevistoFocused ? "k-focus" : ""}`}>
                  <CurrencyInput
                    customInput={Input}
                    id="inv_previs"
                    name="inv_previs"
                    //placeholder="Valor previsto"
                    decimalsLimit={2} 
                    decimalScale={2}
                    decimalSeparator=','     
                    groupSeparator=" "     
                    prefix=""           
                    value={invPrevisto}
                    onValueChange={(valueLocal: any) => setInvPrevisto(valueLocal)}
                    disabled={viewMode}
                    className='siarl-custom-input k-input-md k-rounded-md k-input-solid'
                    onFocus={() => setInvPrevistoFocused(true)}
                    onBlur={() => setInvPrevistoFocused(false)}
                  />
                  <label htmlFor="inv_previs" className="k-label">Valor previsto [€] c/IVA</label>
                </span>
                {/* <Field
                  name="inv_previs"
                  label="Valor Previsto"
                  component={Input}
                  maxLength={25}
                  disabled={viewMode}
                /> */}
              </div>
            </div>
            </>:<></>}
            </div>
            <div className={`${styles.fields} `}>
                <div></div>
                <div>
                <Field
                  name="data_adjudicacao"
                  label="Data de adjudicação"
                  component={DatePicker}
                  calendar={CustomCalendar}
                  format="dd/MM/yyyy"
                  disabled={viewMode}
                />
              </div>

              <div>
                <span className={`k-floating-label-container ${valContrat == null || valContrat == undefined ? "k-empty" : ""} ${valContratFocused ? "k-focus" : ""}`}>
                  <CurrencyInput
                    customInput={Input}
                    id="val_contrat"
                    name="val_contrat"
                    //placeholder="Preço contratual"
                    decimalsLimit={2} 
                    decimalScale={2}
                    decimalSeparator=','     
                    groupSeparator=" "     
                    prefix=""                 
                    value={valContrat}
                    onValueChange={(valueLocal: string | undefined) => {
                     
                      setValContrat(valueLocal);

                      SessionStorageService.setItem("valor_contratado", valueLocal);
                    }}                   
                     disabled={viewMode}
                    className='siarl-custom-input k-input-md k-rounded-md k-input-solid'

                  />
                  <label htmlFor="val_contrat" className="k-label">Preço contratual [€] c/IVA</label>
                </span>

                {/* <Field
                  name="val_contrat"
                  label="Preço contratual"
                  component={Input}
                  maxLength={25}
                  disabled={viewMode}
                  onChange={handleValContratChange}

                /> */}
              </div>
          

            </div>

            <div className={`${styles.fields} `}>

            <div>
                <Field
                  name="taxa_execucao"
                  label="Taxa execução"
                  component={Input}
                  maxLength={10}
                  disabled
                />
              </div>

              <div>
                <span className={`k-floating-label-container ${valPorExecutar == null || valPorExecutar == undefined ? "k-empty" : ""} ${valPorExecutarFocused ? "k-focus" : ""}`}>
                  <CurrencyInput
                    customInput={Input}
                    id="valor_por_executar"
                    name="valor_por_executar"
                    //placeholder="Valor por executar"
                    decimalsLimit={2} 
                    decimalScale={2}
                    decimalSeparator=','     
                    groupSeparator=" "     
                    prefix=""                       
                    value={valPorExecutar}
                    onValueChange={(valueLocal: any) => setValPorExecutar(valueLocal)}
                    disabled
                    className='siarl-custom-input k-input-md k-rounded-md k-input-solid'
                    onFocus={() => setValPorExecutarFocused(true)}
                    onBlur={() => setValPorExecutarFocused(false)}
                  />
                  <label htmlFor="valor_por_executar" className="k-label">Valor por executar [€] c/IVA</label>
                </span>
                {/* <Field
                  name="valor_por_executar"
                  label="Valor por executar"
                  component={Input}
                  maxLength={10}
                  disabled
                /> */}
              </div>

              <div>
                <span className={`k-floating-label-container ${invRealizado == null || invRealizado == undefined ? "k-empty" : ""} ${invRealizadoFocused ? "k-focus" : ""}`}>
                  <CurrencyInput
                    customInput={Input}
                    id="inv_realizado"
                    name="inv_realizado"
                    //placeholder="Investimento realizado"
                    decimalsLimit={2} 
                    decimalScale={2}
                    decimalSeparator=','     
                    groupSeparator=" "     
                    prefix=""                      
                    value={invRealizado}
                    onValueChange={(valueLocal: any) => setInvRealizado(valueLocal)}
                    disabled
                    className='siarl-custom-input k-input-md k-rounded-md k-input-solid'
                    onFocus={() => setInvRealizadoFocused(true)}
                    onBlur={() => setInvRealizadoFocused(false)}
                  />
                  <label htmlFor="inv_realizado" className="k-label">Investimento realizado [€] c/IVA</label>
                </span>
                {/* <Field
                  name="inv_realizado"
                  label="Valor realizado"
                  component={Input}
                  maxLength={25}
                  disabled
                /> */}
              </div>
            </div>
            <div className={`${styles.fields} `}>

              <div>
              <Field
                name="data_ini_e"
                label="Data de inicio de execução"
                component={DatePicker}
                calendar={CustomCalendar}
                format="dd/MM/yyyy"
                disabled={viewMode}
              />
            </div>
             <div>
                <Field
                  name="data_con_e"
                  label="Data de conclusão de execução"
                  component={DatePicker}
                  calendar={CustomCalendar}
                  format="dd/MM/yyyy"
                  disabled={viewMode}

                />
              </div>
              <div>
                <span className={`k-floating-label-container ${revisaoPrecos == null || revisaoPrecos == undefined ? "k-empty" : ""} ${revisaoPrecosFocused ? "k-focus" : ""}`}>
                  <CurrencyInput
                    customInput={Input}
                    id="revisao_precos"
                    name="revisao_precos"
                    //placeholder="Revisão preços"
                    decimalsLimit={2} 
                    decimalScale={2}
                    decimalSeparator=','       
                    groupSeparator=" "     
                    prefix=""                        
                    value={revisaoPrecos}
                    onValueChange={(valueLocal: any) => setRevisaoPrecos(valueLocal)}
                    onChange={handleValRevisaoPrecosChange}
                    disabled
                    className='siarl-custom-input k-input-md k-rounded-md k-input-solid'
                    onFocus={() => setRevisaoPrecosFocused(true)}
                    onBlur={() => setRevisaoPrecosFocused(false)}
                  />
                  <label htmlFor="revisao_precos" className="k-label">Revisão preços [€] c/IVA</label>
                </span>

                {/* <Field
                  name="revisao_precos"
                  label="Revisão preços"
                  component={Input}
                  maxLength={25}
                  disabled={viewMode}
                  onChange={handleValRevisaoPrecosChange}
                  type="number"
                /> */}
              </div>
            </div>

            <div className={styles.espacoVerticalFieldSet}>

            <div className={`${styles.fields} `}>


              <div>
              <AssociacaoEntidadeIntervencao viewMode={viewMode} dataCombo={entidades} label={"Entidades"} title1={"Entidade"} title2={"Ação"} textField={'nome'} dataGrid={datagrid} setDataGrid={setDataGrid} initialValues={getAcaoSelected()}/>  <></>
              </div>       
            </div>
            </div>

            <div className={`${styles.fields} `}>
            <div className={styles.espacoVerticalFieldSet}>
            <div className={styles.fieldsetSubTitulo}>
              Descrição
            </div>
              <div>
                <Field
                  name="descricao"
                  label="Descrição"
                  placeholder="Descrição"
                  component={TextArea}
                  maxLength={3000}
                  style={{opacity: viewMode ? '0.7' : '1'}}
                  onKeyDown={keyPressTextArea}
                />
              </div>
            </div>
            </div>
           
         
        </fieldset>
  
  
    
        <fieldset>
   
          <legend>
            <span className={styles.fieldsetTitulo}>
            Intervenções associadas
            </span>
          </legend>
          {!viewMode  ? (

          <div className={styles.espacoVerticalFieldSet}>
          <button
              title="Adicionar novo"
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary buttonAdicionarNovo btnPrimaryColor"
              onClick={(e) => {
                openModal(e);
              }}
              // disabled={viewMode || !selectedIntervencaoResult?.id}
              >
              <span className="icon-siarl icon-registar k-button-icon"></span>{' '}
              &nbsp;{' '}
              Inserir
            </button>
         </div>
        ) : ""}

        <div className={styles.espacoVerticalFieldSet}>
        <div className={styles.scrollableArea}>
          <Grid
            className={'gridEspeciais'}
            data={gridData.slice(page2.skip, page2.take + page2.skip)}
            pageable={{
              buttonCount: 5,
              info: false,  
              type: 'numeric',
              pageSizes: false,  
              previousNext: true,
            }}
            rowHeight={50}
            total={gridData.length}
            skip={page2.skip}
            take={page2.take}
            onPageChange={handlePageChange2}
            // onRowClick={handleRowClick}

          >
            {!viewMode ?
            
            <GridColumn width={56}
                        cell={(props) => (
                          <td className="k-command-cell">
                            <div style={{cursor:'pointer'}} className={'gridCommand'}>
                              <div
                                role="button"
                                className={styles.gridCommandIconButton}
                                onClick={() => handleRowClick(props.dataItem)}
                              >
                                <FontAwesomeIcon icon={faInfoCircle} title="Editar associação" />
                              </div>
                              <div style={{cursor:'pointer'}}
                                role="button"
                                onClick={() => confirmRemoveAssociacaoIntervencao(props.dataItem)}
                                className={styles.gridCommandIconButton}
                              >
                                <FontAwesomeIcon icon={faRemove} title="Remover associação" />
                              </div>
                            </div>
                          </td>
                        )}
                      />
              : '' }     
            <GridColumn field="id_interv" className={styles.centerAlign}  width="100px" title="ID intervenção" />
            <GridColumn field="designacao.designacao" className={styles.centerAlign} width="110px" title="Designação" />
            <GridColumn field="codigo.codigo" className={styles.centerAlign} width="85px" title="Código" />
            <GridColumn field="intEstado.descricao" className={styles.centerAlign} width="110px" title="Estado" />
            <GridColumn field="id_int_palXXI_tip_nivel3.descricao" className={styles.centerAlign} width="110px" title="Tipo n3" />
            <GridColumn field="percentagem" className={styles.centerAlign} width="120px" title="Percentagem" />
          
          </Grid>
        </div>
        </div>
        </fieldset>
      

        <fieldset>
        <legend>
            <span className={styles.fieldsetTitulo}>
            Fonte de financiamento
            </span>
          </legend>

          <legend>
            <span className={styles.fieldsetSubTitulo}>
            Candidaturas associadas
            </span>
          </legend>
         
        <div className={styles.espacoVerticalFieldSet}>
        <div className={styles.scrollableArea}>
          <Grid
            className={'gridEspeciais'}
            data={gridDataCandidaturas.slice(page2.skip, page2.take + page2.skip).map((item : any) => ({
              ...item,
              inv_comp_total: formatCurrency(item.inv_comp_total),
              inv_nacional_total: formatCurrency(item.inv_nacional_total),
              inv_previsto_total: formatCurrency(item.inv_previsto_total),
            }))}            pageable={{
              buttonCount: 5,
              info: false,  
              type: 'numeric',
              pageSizes: false,  
              previousNext: true,
            }}
            rowHeight={50}
            total={gridDataCandidaturas.length}
            skip={page2.skip}
            take={page2.take}
            onPageChange={handlePageChange2}

          >
                   
            <GridColumn field="id" className={styles.centerAlign} width="100px" title="ID candidatura" />
            <GridColumn field="intInstrumentoFinanciamento.designacao" className={styles.centerAlign} width="145px" title="Entidade comunitária" />
            <GridColumn field="cod_candid" className={styles.centerAlign} width="150px" title="Nº de candidatura " />
            <GridColumn field="intCandidaturaEstado.descricao" className={styles.centerAlign} width="120px" title="Estado" />
            <GridColumn field="inv_comp_total" className={styles.centerAlign} width="135px" title="Valor comunitário" />
            <GridColumn field="inv_nacional_total" className={styles.centerAlign} width="135px" title="Valor nacional" />
          </Grid>
        </div>
        </div>
        
            <legend>
              <span className={styles.fieldsetSubTitulo}>
              Financiamento nacional
              </span>
            </legend>
            {!viewMode  ? (

          <div className={styles.espacoVerticalFieldSet}>
          <button
              title="Adicionar novo"
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary buttonAdicionarNovo btnPrimaryColor"
              onClick={(e) => {
                modalFonteFinanciamento(e);
              }}
              // disabled={viewMode || !selectedIntervencaoResult?.id}
              >
              <span className="icon-siarl icon-registar k-button-icon"></span>{' '}
              &nbsp;{' '}
              Inserir
            </button>
          </div>
          ) : ""}
          <div className={styles.espacoVerticalFieldSet}>
          <div className={styles.scrollableArea}>
            <Grid
              className={'gridEspeciais'}
              data={gridDataFonteFinanciamento.slice(pageFonteFinanciamento.skip, pageFonteFinanciamento.take + pageFonteFinanciamento.skip)}
              pageable={{
                buttonCount: 5,
                info: false,  
                type: 'numeric',
                pageSizes: false,  
                previousNext: true,
              }}
              rowHeight={50}
              total={gridDataCandidaturas.length}
              skip={pageFonteFinanciamento.skip}
              take={pageFonteFinanciamento.take}
              onPageChange={handlePageChangeFonteFinanciamento}

            >
                {!viewMode ?
          
                      <GridColumn width={56}
                                  cell={(props) => (
                                    <td className="k-command-cell">
                                      <div style={{cursor:'pointer'}} className={'gridCommand'}>
                                        <div
                                          role="button"
                                          className={styles.gridCommandIconButton}
                                          onClick={() => handleRowClickFonteFinanciamento(props.dataItem)}
                                        >
                                          <FontAwesomeIcon icon={faInfoCircle} title="Editar associação" />
                                        </div>
                                        <div style={{cursor:'pointer'}}
                                          role="button"
                                          onClick={() => confirmRemoveFonteFinanciamento(props.dataItem)}
                                          className={styles.gridCommandIconButton}
                                        >
                                          <FontAwesomeIcon icon={faRemove} title="Remover associação" />
                                        </div>
                                      </div>
                                    </td>
                                  )}
                                />
                        : ''}
              <GridColumn field="id_entidade.nome" className={styles.centerAlign} width="100px" title="Entidade financiadora nacional" />
              <GridColumn field="valor_financiamento" className={styles.centerAlign}width="135px"  title="Valor [€] c/IVA"
                cell={(props) => {
                let valor = props.dataItem.valor_financiamento;
                    if (typeof valor === 'string') {
                      valor = parseFloat(valor.replace(',', '.'));
                    }

                    const valorFormatado = valor != null ?( !isNaN(valor)
                      ? valor.toLocaleString('pt-PT', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : '') : '';

                    return <td className={styles.centerAlign}>{valorFormatado}</td>;
                  }}
                />
            </Grid>
          </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>
            <span className={styles.fieldsetTitulo}>Localização</span>
          </legend>

          <div className={styles.fields}>
          <div>
              {getAcaoSelected() ?
                <CheckMoreItem
                  list={getAcaoSelected()?.nuts1}
                  property={'nome'}
                  label="NUTS I"
                /> :
                <Field
                  name="nuts1"
                  label="NUTS I"
                  component={ComboBox}
                  textField={'nome'}
                  data={nuts1}
                  onChange={filterNuts2}
                  disabled

                />
              }
            </div>
            <div>
              {getAcaoSelected() ?
                <CheckMoreItem
                  list={getAcaoSelected()?.nuts2}
                  property={'nome'}
                  label="NUTS II"

                /> :
                <Field
                  name="nuts2"
                  label="NUTS II"
                  component={ComboBox}
                  textField={'nome'}
                  data={nuts2Filtered}
                  onChange={filterNuts3}
                  disabled
                />}
            </div>
            <div>
              {getAcaoSelected() ?
                <CheckMoreItem
                  list={getAcaoSelected()?.nuts3}
                  property={'nome'}
                  label="NUTS III"

                /> :
                <Field
                  name="nuts3"
                  label="NUTS III"
                  component={ComboBox}
                  textField={'nome'}
                  data={nuts3Filtered}
                  disabled


                />}
            </div>
          </div>
          <div className={styles.fields}>
          <div>
              {getAcaoSelected() ?
                <CheckMoreItem
                  list={getAcaoSelected()?.distritos}
                  property={'nome'}
                  label="Distrito"
                /> :
                <Field
                  name="distrito"
                  label="Distrito"
                  component={ComboBox}
                  onChange={filterConcelho}
                  textField={'nome'}
                  data={distritos}
                  disabled

                />}
            </div>
            <div>
              {getAcaoSelected() ?
                <CheckMoreItem
                  list={getAcaoSelected()?.concelhos}
                  property={'nome'}
                  label="Concelho"
                /> :
                <Field
                  name="concelho"
                  label="Concelho"
                  component={ComboBox}
                  onChange={filterFreguesia}
                  disabled
                  textField={'nome'}
                  data={concelhosFiltred}
                />}
            </div>
            <div>
              {getAcaoSelected() ?
                <CheckMoreItem
                  list={getAcaoSelected()?.freguesias}
                  property={'nome'}
                  label="Freguesia"
                /> :
                <Field
                  name="freguesia"
                  label="Freguesia"
                  component={ComboBox}
                  disabled
                  textField={'nome'}
                  data={freguesiasFiltred}
                />}
            </div>
          </div>
          <div className={styles.fields}>
          <div>
            {getAcaoSelected() ?
              <CheckMoreItem
                list={getAcaoSelected()?.arhs}
                property={'nome'}
                label="ARH"
              /> :
              <Field
                name="arh"
                label="ARH"
                component={ComboBox}
                textField={'nome'}
                data={arhs}
                disabled

              />}
            </div>
            <div>
            {getAcaoSelected() ?
              <CheckMoreItem
                list={getAcaoSelected()?.capitanias}
                property={'nome'}
                label="Capitania"
              /> :
              <Field
                name="capitania"
                label="Capitania"
                component={ComboBox}
                textField={'nome'}
                data={capitania}
                disabled

              />}
              </div>
              <div>
            {getAcaoSelected() ?
              <CheckMoreItem
                list={getAcaoSelected()?.massasAgua}
                property={'nome'}
                label="Massa de água"
              /> :
              <Field
                name="massaagua"
                label="Massa de água"
                component={ComboBox}
                textField={'nome'}
                data={massaagua}
                disabled

              />}
              </div>
          </div>
          <div className={styles.fields}>
            <div>
              <Field
                name="praia"
                label="Praia (se aplicável)"
                component={ComboBox}
                textField={'nome'}
                filterable={true}
                onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'praias')}}
                data={combos?.praias}
                disabled={viewMode}

              />
            </div>
            <div>
              <Field name="local" label="Local" component={Input} maxLength={500} disabled={viewMode}
  />
            </div>
          </div>
          &nbsp;
        </fieldset>

        <fieldset>
          <legend>
            <span className={styles.fieldsetTitulo}>Tipologia</span>
          </legend>
          <div className={styles.espacoVerticalFieldSet}>
              <div>
                <Field
                  name="id_tipo_n1"
                  label="Tipologia Nível 1 (PAL XXI)"
                  component={ComboBox}
                  textField={'descricao'}
                  filterable={true}
                  onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'acaoPlaneamento1')}}
                  disabled
                  />
              </div>
              <div>
                <Field
                  name="id_tipo_n2"
                  label="Tipologia Nível 2 (PAL XXI)"
                  component={ComboBox}
                  textField={'descricao'}
                  filterable={true}
                  onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'acaoPlaneamento2')}}
                  disabled
                />
              </div>
              <div>
                <Field
                  name="id_tipo_n3"
                  label="Tipologia Nível 3 (PAL XXI)"
                  component={ComboBox}
                  textField={'descricao'}
                  filterable={true}
                  onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'acaoPlaneamento3')}}
                  disabled
                />
              </div>
              <div>
                <Field
                  name="id_tipo_n4"
                  label="Tipologia Nível 4 (Execução)"
                  data={acaoPlaneamento4}
                  component={ComboBox}
                  disabled={viewMode}
                  textField={'descricao'}
                />
              </div>
              <div className={styles.fields}>
              <div>
                  <Field
                    name="tipo_engenharia"
                    label="Tipo de Engenharia"
                    component={ComboBox}
                    textField={'descricao'}
                    filterable={true}
                    onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'tipoEngenharia')}}
                    data={combos?.tipoEngenharia}
                  />
                </div>
              </div>
            <div className={styles.fields}>
                
                <div>
                  <Field
                    name="id_natureza_acao"
                    label="Natureza da ação"
                    component={ComboBox}
                    textField={'descricao'}
                    filterable={true}
                    onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'naturezaAcao')}}
                    data={combos?.naturezaAcao}
                    disabled={viewMode}
                  />
                </div>
            </div>
           
            <div className={styles.fields}>

                <div>
                  <Field
                    name="id_int_acao_componente"
                    label="Componentes da ação"
                    component={MultiSelect}
                    textField={'descricao'}
                    filterable={true}
                    onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'componenteAcao')}}
                    data={combos?.componenteAcao}
                    disabled={viewMode}
                  />
                </div>
              </div>
              <div className={styles.fields}>

              <div>
                      <Field
                        name="id_int_acao_planeamento"
                        label="Tipo de planeamento"
                        component={ComboBox}
                        textField={'descricao'}
                        filterable={true}
                        data={combos?.tipoPlaneamento}
                      />
                    </div>
              </div>

          </div>
              
        </fieldset>

        
        {openModalFonteFinanciamento ? (
          <Dialog
            title="Associação de financiamento nacional à ação"
            className="ModalAssociacoes"
            onClose={cancelModalFinanciamentonacional}
          >
            
            <Form
              onSubmit={handleSubmitModalFonteFinanciamento}
              initialValues={formDataFonteFinanciamento}
              render={(formRenderProps) => (
                <FormElement style={{ width: 500 }}>
                    <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
                        <div className={styles.fields}>
                          <div>
                          <Field
                            name="id_entidade" 
                            onChange={handleFormChangeFonteFinanciamento}  
                            label="Entidade financiadora nacional" 
                            component={ComboBox}
                            maxLength={255}
                            disabled={viewMode}  
                            data={entidadesData}
                            filterable={true}
                            onFilterChange={filterChangeEntidades}
                            textField={'nome'}
                          />
                        </div>
                      </div>
                    <div className={`${styles.fields}`}>
                    <div>
                    <Field
                            name="valor_financiamento" 
                            onChange={handleFormChangeFonteFinanciamento}  
                            label="Valor [€] c/IVA" 
                            component={Input}
                            maxLength={255}
                            disabled={viewMode}  
                          />
                    </div>
                </div>      
                  <div className="k-form-buttons btnsModal">
                  <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                      onClick={cancelModalFinanciamentonacional}
                    >
                      Cancelar
                    </button>
                    <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                      onClick={handleSubmitModalFonteFinanciamento}
                    >
                      Submeter
                    </button>
                  </div>
                  </div>
                </FormElement>
              )}
            />
          </Dialog>
        ) : (
          <></>
        )}

        <fieldset>
          <legend>
            <span className={styles.fieldsetTitulo}>
            Mobilizações associadas
            </span>
          </legend>
         
        <div className={styles.espacoVerticalFieldSet}>
        <div className={styles.scrollableArea}>
          <Grid
            className={'gridEspeciais'}
            data={gridDataMobilizacoes.slice(page2.skip, page2.take + page2.skip)}
            pageable={{
              buttonCount: 5,
              info: false,  
              type: 'numeric',
              pageSizes: false,  
              previousNext: true,
            }}
            rowHeight={50}
            total={gridDataMobilizacoes.length}
            skip={page2.skip}
            take={page2.take}
            onPageChange={handlePageChange2}

          >
                   
            <GridColumn field="id" className={styles.centerAlign} width="100px" title="ID mobilização" />
            <GridColumn field="entidade.nome" className={styles.centerAlign} width="135px" title="Entidade responsável" />
            <GridColumn field="tipo_mo.descricao" className={styles.centerAlign} width="120px" title="Tipo de mobilização" />
            <GridColumn field="data_fim" className={styles.centerAlign} width="90" title="Data de fím" />
            <GridColumn field="volume_acao" className={styles.centerAlign} width="100px" title="Volume da ação" />
            <GridColumn field="praia.nome" className={styles.centerAlign} width="100px" title="Praia" />
            <GridColumn field="intMobObjetivoDeposicaoNivel1.descricao" className={styles.centerAlign} width="100px" title="Objetivo nível 1" />

          
          </Grid>
        </div>
        </div>
        </fieldset>


        {/* <fieldset>
          <legend>
            <span className={styles.fieldsetTitulo}>
              Indicadores de concretização
            </span>
          </legend>
          {!viewMode  ? (

          <div className={styles.espacoVerticalFieldSet}>
             <div className={styles.fields}>     
                    
               <div>
              <Field
                name="id_indicador"
                label="Indicadores"
                component={ComboBox}
                data={intIndicador}
                onChange={(e) => setSelectedIndicador(e.target.value)}
                textField={'descricao'}
                filterable={true}
                value={selectedIndicador}
                onFilterChange={filterChange}
                disabled={viewMode} 
              />
              </div>
               <div>
                <Field
                  name="valor"
                  label="Valor"
                  component={Input}
                  maxLength={25}
                  onChange={(e) => setValorIndicador(e.target.value)}
                  disabled={viewMode}
                  value={valorIndicador}
                  type="number"
                />
            </div>  

          <button
              title="Inserir indicador"
              className={styles.btnInserirIndicador}
              onClick={handleInsertIndicador}
              type="button"
              // disabled={viewMode || !selectedIntervencaoResult?.id}
              >
              <span className="icon-siarl icon-registar k-button-icon"></span>{' '}
              &nbsp;{' '}
            </button>
         </div>
         </div>

        ) : ""}

         
        <div className={styles.espacoVerticalFieldSet}>
          <div className={styles.scrollableArea}>
          <Grid
            className={'gridEspeciais'}
            data={gridDataIndicadores.slice(page2.skip, page2.take + page2.skip)}
            pageable={{
              buttonCount: 5,
              info: false,  
              type: 'numeric',
              pageSizes: false,  
              previousNext: true,
            }}
            rowHeight={50}
            total={gridDataIndicadores.length}
            skip={page2.skip}
            take={page2.take}
            onPageChange={handlePageChange2}

          >
            {!viewMode? (
            <GridColumn
              width="50px"
              cell={(props) => (
                <td>
                  <button
                    onClick={() => confirmRemoveIndicador(props.dataItem)}
                    className={styles.gridCommandIconButton}>
                  <FontAwesomeIcon icon={faRemove} />
                  </button>
                
                </td>
              )}
            />
          ) : ""}
         
            <GridColumn field="id_indicador.descricao" width="170px" className={styles.centerAlign}  title="Indicador de concretização" />
            <GridColumn field="valor" width="170px" className={styles.centerAlign}  title="Valor" />
            
          </Grid>
          </div>
        </div>
        </fieldset> */}
  
        <fieldset>
          <legend>
            <span className={styles.fieldsetTitulo}>Observações</span>
          </legend>

          <div className={`${styles.fields} ${styles.espacoVerticalFieldSet}`}>
            <Field
              name="obs"
              label="Observações"
              component={TextArea}
              textField={'nome'}
              maxLength={528}
              style={{opacity: viewMode ? '0.7' : '1'}}
              onKeyDown={keyPressTextArea}
            />
          </div>
        </fieldset>

      </div>

        {openModalDescartarFinanciamento ? (
                <Dialog
                  
                  className={styles.dialogDesconformidades}
                  onClose={() => setOpenModalDescartarFinanciamento(false)}
                >
                  
                  <Form
                    initialValues={
                      {
                      } 
                    }
                    render={(formRenderProps) => (
                      <FormElement style={{ maxWidth: 500 }}>
                        <fieldset>
                          <span className="textDescartar">{'Apagar'} associação  </span>
                          <br></br>
                          <span>{'Tem a certeza que pretende apagar a associação com fonte de financiamento?'}</span>
                        </fieldset>
                        <div className="k-form-buttons btnModal">         
                          <button
                            type={'submit'}
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base capitalizeText btnWhite"
                            onClick={() => setOpenModalDescartarFinanciamento(false)}
                          >
                            Não
                          </button>   
      
                          <button
                            type={'submit'}
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary btnImportar capitalizeText"
                            onClick={removeFonteFinanciamento }
                          >
                            Sim
                          </button>
                        </div>
                      </FormElement>
                    )}
                  />
                </Dialog>
              ) : (
                <></>
              )}

      {openModalDescartar ? (
          <Dialog
            
            className={styles.dialogDesconformidades}
            onClose={() => setOpenModalDescartar(false)}
          >
            
            <Form
              initialValues={
                {
                } 
              }
              render={(formRenderProps) => (
                <FormElement style={{ maxWidth: 500 }}>
                  <fieldset>
                    <span className="textDescartar">{'Apagar'} registo  </span>
                    <br></br>
                    <span>{'Tem a certeza que pretende apagar a associação?'}</span>
                  </fieldset>
                  <div className="k-form-buttons btnModal">         
                    <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base capitalizeText btnWhite"
                      onClick={() => setOpenModalDescartar(false)}
                    >
                      Não
                    </button>

                    <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary btnImportar capitalizeText"
                      onClick={removeAssociacaoIntervencao}
                    >
                      Sim
                    </button>
                  </div>
                </FormElement>
              )}
            />
          </Dialog>
        ) : (
          <></>
        )}

{openModalIntervencaoAcao ? (
          <Dialog
            title="Associação de intervenção à ação"
            className="ModalAssociacoes"
            onClose={cancelModal}
          >
            
            <Form
              onSubmit={handleSubmitModal}
              initialValues={formData}
              render={(formRenderProps) => (
                <FormElement style={{ width: 500 }}>
                  <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
                    
                      <div className={styles.fields}>
                        <Field
                          name="id_interv" 
                          onChange={handleFormChange}  
                          label="ID Intervenção" 
                          component={Input}  
                          disabled={viewMode}  
                          type="number"
                          value={idInterv}
                        />
                      </div>
                      <div className={styles.fields}>
                        <div>
                        <Field
                          name="designacao"
                          label="Designação"
                          component={ComboBox}
                          filterable={true}
                          onFilterChange={(e: any) => { filterCombo_Multiselect(e, 'designacaoIntervencao') }}
                          textField={'designacao'}
                          data={combos?.designacaoIntervencao}
                          value={designacao}
                          disabled={viewMode}
                          onChange={(e) => {
                            setDesignacao(e.value)
                          }}
                        />
                      </div>
                  
                      </div>
                      <div className={styles.fields}>
                        <div>
                        <Field
                            name="codigo"
                            label="Código"
                            component={ComboBox}
                            filterable={true}
                            onFilterChange={(e: any) => { filterCombo_Multiselect(e, 'codigoIntervencao') }}
                            textField={'codigo'}
                            data={combos?.codigoIntervencao}
                            disabled={viewMode}
                            value={codigo}
                            onChange={(e) => {
                              setCodigo(e.value)
                            }}
                          />
                      </div>
                    </div>

                    <div className={`${styles.fields}`}>
                  <div>
                      <Field
                          name="intEstado"
                          label="Estado"
                          textField={'descricao'}
                          component={ComboBox}                     
                          disabled
                          onChange={handleFormChange}
                          />
                  </div>
              </div>      
                  <div className={`${styles.fields}`}>
                  <div>
                      <Field
                          name="id_int_palXXI_tip_nivel3"
                          label="Tipologia Nivel 3"
                          component={ComboBox}      
                          textField={'descricao'}
                          disabled
                          onChange={handleFormChange}
                          />
                  </div>
              </div>      
              <div className={`${styles.fields}`}>
                  <div>
                      <Field
                          type="number"
                          name="percentagem"
                          label="Percentagem"
                          component={Input}                     
                          onChange={handleFormChange}
                          />
                  </div>
              </div>      
              <div className="k-form-buttons btnsModal">
              <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                      onClick={cancelModal}
                    >
                      Cancelar
                    </button>
                    <button
                      type={'button'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                      onClick={(e) => handlePesquisarIntervencao(e, formRenderProps)}                    
                      >
                    
                      Pesquisar
                    </button>
                    <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                      onClick={formRenderProps.onSubmit}
                      disabled={!findIntervencao}
                    >
                      Submeter
                    </button>
                    </div>              
                    </div>
                </FormElement>
              )}
            />
          </Dialog>
        ) : (
          <></>
        )}




{openModalDescartarIndicador ? (
          <Dialog
            
            className={styles.dialogDesconformidades}
            onClose={() => setOpenModalDescartarIndicador(false)}
          >
            
            <Form
              initialValues={
                {
                } 
              }
              render={(formRenderProps) => (
                <FormElement style={{ maxWidth: 500 }}>
                  <fieldset>
                    <span className="textDescartar">{'Apagar'} indicador  </span>
                    <br></br>
                    <span>{'Tem a certeza que pretende apagar o indicador?'}</span>
                  </fieldset>
                  <div className="k-form-buttons btnModal">         
                    <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base capitalizeText btnWhite"
                      onClick={() => setOpenModalDescartarIndicador(false)}
                    >
                      Não
                    </button>

                    <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary btnImportar capitalizeText"
                      onClick={removeIndicador}
                    >
                      Sim
                    </button>
                  </div>
                </FormElement>
              )}
            />
          </Dialog>
        ) : (
          <></>
        )}




    </>
  )
}

